
import * as R from 'ramda';
export const distributionOrderState = {
    distributionOrderData: null,
    distributionOrderList: null,
    distributionOrderDetails: null,

    order_types: [
        {
            value: 1,
            label: "Invoice Order",
            textkey: "ot_invoice_order"
        },
        {
            textkey: "ot_consignment",
            label: "Consignment",
            value: 2
        },
        {
            value: 3,
            textkey: "ot_return_credit_note",
            label: "Return Credit Note"
        },
        {
            value: 4,
            label: "Consignment Return",
            textkey: "ot_return_consignment"
        },
        {
            value: 5,
            label: "Promo Order",
            textkey: "ot_promo_order"
        },
        {
            value: 6,
            textkey: "ot_defects_note",
            label: "Defects Note"
        },
        {
            value: 7,
            textkey: "ot_defects_consignment",
            label: "Defects Consignment"
        },
        {
            label: "Price Adjustment",
            textkey: "ot_price_adjustment",
            value: 8
        },
        {
            value: 9,
            textkey: "ot_statement",
            label: "Invoice Consignment"
        },
        {
            textkey: "ot_ret_to_vendor",
            label: "Return to vendor",
            value: 10
        }
    ],
}




